module.exports = __webpack_public_path__ + "static/fipcbluewhale2-55ec2fa6f8ef69393a961ca07faeac65.jpeg";